import { Screen } from '~/screens/users/new';

export const UsersNew: React.FC = () => <Screen />;
